"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * JNext Contestformat API for client FE
 * Example of usage of OpenAPI for documentation and code generation.
 *
 * The version of the OpenAPI document: 0.0.1-SNAPSHOT
 * Contact: consulente.colombo@jakala.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypeContestEnum = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var TypeContestEnum;
(function (TypeContestEnum) {
    TypeContestEnum["Public"] = "PUBLIC";
    TypeContestEnum["Private"] = "PRIVATE";
})(TypeContestEnum = exports.TypeContestEnum || (exports.TypeContestEnum = {}));
